<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="msa-app">
    <!-- ========== STICKY HEADER ========== -->
    <header class="desktop-header-container">
      <div class="brand-row">
        <div class="ms-logo-container">
          <img
            src="/MS LOGO.jpg"
            alt="Market Sphere Agencies logo"
            @error="handleLogoError"
          />
        </div>
        <span>MARKET SPHERE AGENCIES</span>
        <button @click="openMobileMenu" class="hamburger-btn">
          <span class="menu-text">MENU</span>
        </button>
      </div>

      <!-- DESKTOP NAV -->
      <nav class="desktop-nav">
        <router-link to="/" class="active">HOME</router-link>
        <router-link to="/marketplace">MARKETPLACE</router-link>
        <router-link to="/jobs">JOBS</router-link>
        <router-link to="/professionals">PROFESSIONALS</router-link>
        <router-link to="/dashboard">DASHBOARD</router-link>
        <router-link to="/orders-requests">POST NEED</router-link>
        <router-link to="/messaging">MESSAGES</router-link>
        <router-link to="/courses-books">COURSES/BOOKS</router-link>
        <router-link to="/entertainment">ENTERTAINMENT</router-link>
        <router-link to="/book-ride">BOOK RIDE</router-link>
        <router-link to="/my-posts">MY POSTS</router-link>
        <router-link to="/reviews">REVIEWS</router-link>
        <router-link to="/community-forum">FORUM</router-link>
        <router-link to="/analytics">ANALYTICS</router-link>
        <router-link to="/admin/dashboard">ADMIN</router-link>
        <router-link to="/developer-space">DEV SPACE</router-link>
        <router-link to="/roles" class="roles-nav-link">
          <i class="fas fa-user-tie"></i> APPLY ROLE
        </router-link>
        <router-link to="/donate" class="donate-nav-link">
          <i class="fas fa-heart"></i> DONATE
        </router-link>
        <router-link to="/maintenance">MAINTENANCE</router-link>
        <router-link to="/auth/signin" class="desktop-login-btn"
          ><i class="fas fa-sign-in-alt"></i> LOGIN</router-link
        >
      </nav>
    </header>

    <!-- ========== MOBILE MENU PANEL ========== -->
    <div
      class="mobile-menu-overlay"
      :class="{ active: mobileMenuOpen }"
      @click="closeMobileMenu"
    ></div>
    <div class="mobile-menu-panel" :class="{ active: mobileMenuOpen }">
      <div class="mobile-menu-header">
        <div class="ms-logo-container">
          <img
            src="/MS LOGO.jpg"
            alt="Market Sphere Agencies logo"
            @error="handleLogoError"
          />
        </div>
        <button @click="closeMobileMenu" class="close-btn">&times;</button>
      </div>

      <div class="mobile-menu-section">
        <div class="menu-label">MENU</div>
        <router-link to="/" class="mobile-menu-item" @click="closeMobileMenu"
          ><i class="fas fa-home"></i> HOME</router-link
        >
        <router-link
          to="/marketplace"
          class="mobile-menu-item"
          @click="closeMobileMenu"
          ><i class="fas fa-store"></i> MARKETPLACE</router-link
        >
        <router-link
          to="/courses-books"
          class="mobile-menu-item"
          @click="closeMobileMenu"
          ><i class="fas fa-book"></i> COURSES/BOOKS</router-link
        >
        <router-link
          to="/jobs"
          class="mobile-menu-item"
          @click="closeMobileMenu"
          ><i class="fas fa-briefcase"></i> JOBS</router-link
        >
        <router-link
          to="/professionals"
          class="mobile-menu-item"
          @click="closeMobileMenu"
          ><i class="fas fa-user-md"></i> PROFESSIONALS</router-link
        >
        <router-link
          to="/dashboard"
          class="mobile-menu-item"
          @click="closeMobileMenu"
          ><i class="fas fa-chart-pie"></i> DASHBOARD</router-link
        >
        <router-link
          to="/orders-requests"
          class="mobile-menu-item"
          @click="closeMobileMenu"
          ><i class="fas fa-clipboard-list"></i> POST NEED</router-link
        >
        <router-link
          to="/messaging"
          class="mobile-menu-item"
          @click="closeMobileMenu"
          ><i class="fas fa-comment"></i> MESSAGES</router-link
        >
        <router-link
          to="/entertainment"
          class="mobile-menu-item"
          @click="closeMobileMenu"
          ><i class="fas fa-film"></i> ENTERTAINMENT</router-link
        >
        <router-link
          to="/book-ride"
          class="mobile-menu-item"
          @click="closeMobileMenu"
          ><i class="fas fa-car"></i> BOOK RIDE</router-link
        >
        <router-link
          to="/my-posts"
          class="mobile-menu-item"
          @click="closeMobileMenu"
        >
          <i class="fas fa-file-alt"></i> MY POSTS
        </router-link>
        <router-link
          to="/reviews"
          class="mobile-menu-item"
          @click="closeMobileMenu"
        >
          <i class="fas fa-star"></i> REVIEWS
        </router-link>
        <router-link
          to="/community-forum"
          class="mobile-menu-item"
          @click="closeMobileMenu"
          ><i class="fas fa-users"></i> FORUM</router-link
        >
        <router-link
          to="/analytics"
          class="mobile-menu-item"
          @click="closeMobileMenu"
          ><i class="fas fa-chart-line"></i> ANALYTICS</router-link
        >
        <router-link
          to="/admin/dashboard"
          class="mobile-menu-item"
          @click="closeMobileMenu"
          ><i class="fas fa-shield"></i> ADMIN</router-link
        >
        <router-link
          to="/developer-space"
          class="mobile-menu-item"
          @click="closeMobileMenu"
          ><i class="fas fa-code"></i> DEV SPACE</router-link
        >
        <router-link
          to="/roles"
          class="mobile-menu-item roles-mobile-item"
          @click="closeMobileMenu"
        >
          <i class="fas fa-user-tie" style="color: #f5b301;"></i> APPLY ROLE
        </router-link>
        <router-link
          to="/donate"
          class="mobile-menu-item donate-mobile-item"
          @click="closeMobileMenu"
        >
          <i class="fas fa-heart" style="color: #f5b301;"></i> DONATE
        </router-link>
        <router-link
          to="/maintenance"
          class="mobile-menu-item"
          @click="closeMobileMenu"
          ><i class="fas fa-tools"></i> MAINTENANCE</router-link
        >
      </div>

      <router-link
        to="/auth/signin"
        class="mobile-menu-login"
        @click="closeMobileMenu"
      >
        <i class="fas fa-sign-in-alt"></i> LOGIN / SIGN UP
      </router-link>
    </div>

    <!-- ========== HERO SECTION ========== -->
    <section class="hero-section">
      <div class="hero-content">
        <span class="trust-badge"
          ><i class="fas fa-shield-alt"></i> ONE ACCOUNT — INFINITE
          MARKETS</span
        >
        <h1 class="hero-title">The Universal Digital<br /><span class="economy-os">Economy OS</span></h1>
        <p class="hero-description">
          <span class="hero-text-line"
            >Buy, sell, work, consult, get entertained — one verified</span
          >
          <span class="hero-text-line">profile across all sectors. Book rides anywhere.</span>
        </p>

        <!-- Compact search bar -->
        <div class="search-container">
          <i class="fas fa-search search-icon"></i>
          <input
            type="text"
            v-model="searchQuery"
            @input="simulateAI"
            @keyup.enter="performSearch"
            placeholder="Search for any service, job, or product..."
            class="search-input"
          />
          <button class="search-btn btn-hover-effect" @click="performSearch">SEARCH</button>
        </div>
        <div v-if="aiSuggestions.length" class="ai-suggestions">
          <button
            v-for="s in aiSuggestions"
            :key="s"
            class="suggestion-item"
            type="button"
            @click="applySuggestion(s)"
          >
            <i class="fas fa-robot gold-text"></i> {{ s }}
          </button>
        </div>
        <div v-if="searchPerformed" class="search-results">
          <div class="search-results-header">
            <div>
              <strong>Results for "{{ searchQuery }}"</strong>
              <span class="search-results-count">
                {{ searchTotalCount }} matches
              </span>
            </div>
            <button class="btn-outline search-clear" @click="clearSearch">CLEAR</button>
          </div>
          <div v-if="searchLoading" class="search-results-empty">Searching...</div>
          <div v-else-if="searchError" class="search-results-empty error">{{ searchError }}</div>
          <div v-else>
            <div class="search-group" v-if="searchResults.marketplace.length">
              <h4>Marketplace Items</h4>
              <div class="search-cards">
                <div v-for="item in searchResults.marketplace" :key="item.id" class="search-card">
                  <div>
                    <strong>{{ item.title }}</strong>
                    <div class="search-meta">{{ item.category }} · ${{ item.price }}</div>
                  </div>
                  <button class="btn-primary" @click="goToMarketplace(item.query)">VIEW</button>
                </div>
              </div>
            </div>
            <div class="search-group" v-if="searchResults.jobs.length">
              <h4>Jobs</h4>
              <div class="search-cards">
                <div v-for="job in searchResults.jobs" :key="job.id" class="search-card">
                  <div>
                    <strong>{{ job.title }}</strong>
                    <div class="search-meta">{{ job.category }}</div>
                  </div>
                  <button class="btn-primary" @click="goToJobs(job.query)">VIEW</button>
                </div>
              </div>
            </div>
            <div class="search-group" v-if="searchResults.professionals.length">
              <h4>Professionals</h4>
              <div class="search-cards">
                <div v-for="pro in searchResults.professionals" :key="pro.id" class="search-card">
                  <div>
                    <strong>{{ pro.name }}</strong>
                    <div class="search-meta">{{ pro.role }}</div>
                  </div>
                  <button class="btn-primary" @click="goToProfessionals(pro.query)">VIEW</button>
                </div>
              </div>
            </div>
            <div v-if="searchTotalCount === 0" class="search-results-empty">
              No results found. Try another keyword.
            </div>
          </div>
        </div>
      </div>

      <div class="hero-sphere">
        <div class="sphere-container">
          <div class="sphere-inner">
            <span class="sphere-text">MSA</span>
          </div>
          <div class="sphere-dot gold-dot"></div>
          <div class="sphere-dot green-dot"></div>
          <i class="fas fa-globe-americas globe-icon"></i>
        </div>
      </div>
    </section>

    <!-- ========== MARKET SECTORS GRID (clickable) ========== -->
    <section class="sectors-section">
      <h2 class="section-title">
        EXPLORE <span class="gold-text">SECTORS</span>
      </h2>
      <div class="sectors-grid">
        <div
          v-for="sector in sectors"
          :key="sector.name"
          class="glass-card sector-card"
          @click="openSectorModal(sector)"
        >
          <i :class="sector.icon" class="sector-icon"></i>
          <h3 class="sector-name">{{ sector.name }}</h3>
          <span class="sector-stats">{{ sector.stats }} listings</span>
        </div>
      </div>
    </section>

    <!-- ========== LIVE ACTIVITY FEED + VERIFIED PROFESSIONALS ========== -->
    <section class="activity-section">
      <div class="activity-feed">
        <div class="activity-header">
          <h2 class="activity-title">
            <i class="fas fa-bolt gold-text"></i> LIVE ACTIVITY
          </h2>
          <span class="activity-counter">{{ activityCounter }} ACTIONS NOW</span>
        </div>
        <div class="feed-container">
          <div v-for="(act, idx) in activityFeed" :key="idx" class="feed-item">
            <div class="feed-icon">{{ act.initials }}</div>
            <div class="feed-content">
              <div class="feed-text-wrapper">
                <span class="feed-text" v-html="act.text"></span>
                <span class="feed-time">{{ act.time }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="verified-pros">
        <h2 class="pros-title">
          <span class="badge-verified"
            ><i class="fas fa-check-circle"></i> VERIFIED</span
          >
          PROFESSIONALS
        </h2>
        <div class="pros-list">
          <div v-for="pro in pros" :key="pro.name" class="glass-card pro-card">
            <div class="pro-avatar">{{ pro.initials }}</div>
            <div class="pro-info">
              <strong class="pro-name">{{ pro.name }}</strong>
              <div class="pro-details">
                {{ pro.role }} · ⭐ {{ pro.rating }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ========== HOW IT WORKS (3 STEPS) ========== -->
    <section class="steps-section">
      <h2 class="steps-title">
        ONE ACCOUNT, <span class="deep-blue">THREE STEPS</span>
      </h2>
      <div class="steps-container">
        <div class="step-item">
          <span class="step-number">1</span>
          <h3 class="step-heading">VERIFY IDENTITY</h3>
          <p class="step-description">
            Secure KYC, phone & email — one global passport
          </p>
        </div>
        <div class="step-item">
          <span class="step-number">2</span>
          <h3 class="step-heading">ACTIVATE ROLES</h3>
          <p class="step-description">
            Seller, buyer, pro, agency — switch anytime
          </p>
        </div>
        <div class="step-item">
          <span class="step-number">3</span>
          <h3 class="step-heading">TRADE & GROW</h3>
          <p class="step-description">Escrow, smart contracts, trust scores</p>
        </div>
      </div>
    </section>

    <!-- ========== GLOBAL STATS ========== -->
    <section class="stats-section">
      <div class="chart-container">
        <div class="chart-header">
          <i class="fas fa-map-marked-alt chart-icon"></i>
          <h2 class="chart-title">GLOBAL LIVE TRANSACTIONS</h2>
        </div>
        <canvas id="globalChart" ref="globalChart"></canvas>
        <div class="chart-footer">
          <div class="chart-growth">
            <span class="positive">▲ 12.4%</span> THIS WEEK
          </div>
          <div class="chart-countries">
            <i class="fas fa-circle" style="color: #0b1c2d"></i> <strong>148 COUNTRIES</strong>
          </div>
        </div>
      </div>
      <div class="volume-card">
        <h3 class="volume-number">$2.8B+</h3>
        <p class="volume-label">PROCESSED VOLUME · Q2</p>
        <div class="volume-badges">
          <span class="badge-outline">GOV. TRUSTED</span>
          <span class="badge-solid">ISO 27001</span>
        </div>
      </div>
    </section>

    <!-- ========== SUPPORT MSA CARD ========== -->
    <section class="support-section">
      <div class="support-card">
        <div class="support-content">
          <div class="support-icon-container">
            <i class="fas fa-heart support-icon"></i>
            <i class="fas fa-hand-holding-heart support-icon-secondary"></i>
          </div>
          <div class="support-text">
            <h2 class="support-title">Support the Future of Digital Economy</h2>
            <p class="support-description">
              MSA is building the world's first universal digital operating system — free for everyone. 
              Your donation helps us maintain servers, develop new features, and keep the platform 
              accessible to millions worldwide. Every contribution, big or small, powers the revolution.
            </p>
            <div class="support-stats">
              <div class="support-stat">
                <span class="stat-number">2,847</span>
                <span class="stat-label">SUPPORTERS</span>
              </div>
              <div class="support-stat">
                <span class="stat-number">$50</span>
                <span class="stat-label">RAISED</span>
              </div>
              <div class="support-stat">
                <span class="stat-number">148</span>
                <span class="stat-label">COUNTRIES</span>
              </div>
            </div>
            <router-link to="/donate" class="support-btn">
              <i class="fas fa-heart"></i> DONATE TO MSA
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- ========== FOOTER ========== -->
    <footer class="footer">
      <div class="footer-main">
        <div class="footer-brand">
          <div class="ms-logo-container footer-logo">
            <img
              src="/MS LOGO.jpg"
              alt="Market Sphere Agencies logo"
              @error="handleLogoError"
            />
          </div>
          <p class="footer-brand-name">MARKET SPHERE AGENCIES</p>
          <p class="footer-tagline">One Account → Infinite Markets</p>
          <router-link to="/guide" class="footer-guide-btn">
            <i class="fas fa-compass"></i> MSA GUIDE
          </router-link>
        </div>
        <div class="footer-links">
          <div class="footer-column">
            <strong>PLATFORM</strong>
            <router-link to="/about">About</router-link>
            <router-link to="/auth/signup">Sign up</router-link>
            <router-link to="/trust">Trust & Safety</router-link>
          </div>
          <div class="footer-column">
            <strong>CONNECT</strong>
            <router-link to="/community-forum">Forum</router-link>
            <router-link to="/developer-space">Developers</router-link>
            <router-link to="/maintenance">Status</router-link>
          </div>
          <div class="footer-column">
            <strong>SUPPORT</strong>
            <router-link to="/roles" class="footer-role-link">
              <i class="fas fa-user-tie" style="color: #f5b301;"></i> Apply Role
            </router-link>
            <router-link to="/donate" class="footer-donate-link">
              <i class="fas fa-heart" style="color: #f5b301;"></i> Donate
            </router-link>
            <router-link to="/guide">Guide</router-link>
            <router-link to="/subscription">Subscription</router-link>
          </div>
        </div>
      </div>
      <div class="footer-copyright">
        © {{ currentYear }} MARKET SPHERE AGENCIES — UNIVERSAL DIGITAL ECONOMY OS
      </div>
    </footer>

    <!-- ========== SECTOR EXPLORATION MODAL ========== -->
    <div
      v-if="showSectorModal"
      class="modal-overlay"
      @click.self="closeSectorModal"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">
            <i :class="selectedSector?.icon" class="modal-icon"></i>
            {{ selectedSector?.name }}
          </h2>
          <button @click="closeSectorModal" class="modal-close">&times;</button>
        </div>

        <div class="modal-stats">
          <span class="stats-badge"
            >{{ selectedSector?.stats }} ACTIVE LISTINGS</span
          >
        </div>

        <p class="modal-description">
          Explore top services and professionals in the
          {{ selectedSector?.name }} sector.
        </p>

        <div v-if="sectorItems.length" class="modal-items-grid">
          <div
            v-for="item in sectorItems"
            :key="item.name"
            class="glass-card modal-item"
          >
            <i :class="item.icon" class="item-icon"></i>
            <h4 class="item-name">{{ item.name }}</h4>
            <p class="item-providers">{{ item.count }} {{ item.label }}</p>
            <p v-if="item.price !== null && item.price !== undefined && item.price !== ''" class="item-price">
              from ${{ formatPrice(item.price) }}
            </p>
          </div>
        </div>
        <p v-else class="modal-empty">
          {{ sectorEmptyMessage || 'No listings yet.' }}
        </p>

        <div class="modal-pros-section">
          <h4 class="modal-pros-title">{{ modalProsTitle }}</h4>
          <div v-if="sectorPros.length">
            <div v-for="pro in sectorPros" :key="pro.name" class="modal-pro-item">
              <div class="modal-pro-avatar">{{ pro.initials }}</div>
              <div class="modal-pro-info">
                <strong>{{ pro.name }}</strong>
                <div class="modal-pro-details">
                  {{ pro.meta }}
                </div>
              </div>
            </div>
          </div>
          <p v-else class="modal-empty">No professionals listed yet.</p>
        </div>

        <div class="modal-actions">
          <button class="btn-primary modal-browse-btn" @click="browseSector">
            BROWSE ALL
          </button>
          <button class="btn-outline modal-close-btn" @click="closeSectorModal">
            CLOSE
          </button>
        </div>
      </div>
    </div>

    <!-- ========== AI ASSISTANT ========== -->
    <div class="ai-assistant">
      <div
        class="ai-chat-toggle"
        @click="toggleAIChat"
        :class="{ dim: isScrolledFar }"
        title="MSA AI ASSISTANT"
      >
        <span class="ai-text">AI</span>
        <span class="ai-pulse"></span>
      </div>

      <div v-if="aiChatOpen" class="ai-chat-window">
        <div class="ai-chat-header">
          <div class="ai-header-info">
            <div class="ai-avatar">
              <i class="fas fa-brain"></i>
            </div>
            <div>
              <span class="ai-name">MSA AI ASSISTANT</span>
              <span class="ai-status">● ONLINE · GPT-4</span>
            </div>
          </div>
          <button @click="aiChatOpen = false" class="ai-close">&times;</button>
        </div>

        <div class="ai-chat-messages">
          <div class="ai-message bot">
            Hi! I'm your MSA AI concierge. Need help finding a service,
            posting a job, or verifying your account?
          </div>
          <div
            v-for="msg in aiConversation"
            :key="msg.id"
            :class="['ai-message', msg.sender]"
          >
            {{ msg.text }}
          </div>
        </div>

        <div class="ai-chat-input">
          <input
            type="text"
            v-model="aiQuery"
            @keyup.enter="sendAIQuery"
            placeholder="Ask me anything..."
            class="ai-input-field"
          />
          <button @click="sendAIQuery" class="ai-submit-btn">
            <span class="send-text">SEND</span>
          </button>
        </div>
      </div>
    </div>

    <!-- ========== MOBILE BOTTOM NAV ========== -->
    <div class="mobile-bottom-nav">
      <router-link to="/" class="active"
        ><i class="fas fa-home"></i><span>HOME</span></router-link
      >
      <router-link to="/marketplace"
        ><i class="fas fa-store"></i><span>MARKET</span></router-link
      >
      <router-link to="/courses-books"
        ><i class="fas fa-book"></i><span>COURSES</span></router-link
      >
      <router-link to="/my-posts"
        ><i class="fas fa-file-alt"></i><span>POSTS</span></router-link
      >
      <router-link to="/reviews"
        ><i class="fas fa-star"></i><span>REVIEWS</span></router-link
      >
      <router-link to="/messaging"
        ><i class="fas fa-comment"></i><span>CHAT</span></router-link
      >
      <router-link to="/entertainment"
        ><i class="fas fa-film"></i><span>ENTERTAIN</span></router-link
      >
      <router-link to="/roles" class="roles-mobile-nav"
        ><i class="fas fa-user-tie"></i><span>ROLES</span></router-link
      >
      <router-link to="/donate" class="donate-mobile-nav"
        ><i class="fas fa-heart"></i><span>DONATE</span></router-link
      >
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import Chart from "chart.js/auto";

const router = useRouter();
const API_BASE = process.env.VUE_APP_API_URL
  ? process.env.VUE_APP_API_URL.replace(/\/$/, "")
  : "";

// Current year for copyright
const currentYear = ref(new Date().getFullYear());

// Mobile menu
const mobileMenuOpen = ref(false);
function openMobileMenu() {
  mobileMenuOpen.value = true;
  document.body.style.overflow = "hidden";
}
function closeMobileMenu() {
  mobileMenuOpen.value = false;
  document.body.style.overflow = "";
}

// Logo error fallback
function handleLogoError(e) {
  e.target.style.display = 'none';
  const container = e.target.parentNode;
  const textLogo = document.createElement('div');
  textLogo.className = 'text-logo';
  textLogo.innerHTML = 'MSA';
  textLogo.style.width = '100%';
  textLogo.style.height = '100%';
  textLogo.style.display = 'flex';
  textLogo.style.alignItems = 'center';
  textLogo.style.justifyContent = 'center';
  textLogo.style.backgroundColor = '#0B1C2D';
  textLogo.style.color = '#F5B301';
  textLogo.style.fontWeight = '800';
  textLogo.style.fontSize = window.innerWidth <= 768 ? '1.2rem' : '1.4rem';
  textLogo.style.borderRadius = '50%';
  container.appendChild(textLogo);
}

// AI Assistant
const aiChatOpen = ref(false);
const aiQuery = ref("");
const aiConversation = ref([]);
const isScrolledFar = ref(false);

function toggleAIChat() {
  aiChatOpen.value = !aiChatOpen.value;
}

function sendAIQuery() {
  if (!aiQuery.value.trim()) return;
  aiConversation.value.push({
    id: Date.now(),
    sender: "user",
    text: aiQuery.value,
  });
  setTimeout(() => {
    aiConversation.value.push({
      id: Date.now(),
      sender: "bot",
      text: "I found 3 matching services for you. Would you like to see them?",
    });
  }, 1000);
  aiQuery.value = "";
}

// Search
const searchQuery = ref("");
const aiSuggestions = ref([]);
const searchLoading = ref(false);
const searchError = ref("");
const searchPerformed = ref(false);
const searchResults = ref({
  marketplace: [],
  jobs: [],
  professionals: [],
});

const searchTotalCount = computed(() => {
  return (
    searchResults.value.marketplace.length +
    searchResults.value.jobs.length +
    searchResults.value.professionals.length
  );
});

function simulateAI() {
  if (searchQuery.value.length > 2) {
    aiSuggestions.value = [
      "freelance UX",
      "real estate lawyer",
      "solar panel installation",
      "Spanish tutor",
    ];
  } else {
    aiSuggestions.value = [];
  }
}

function applySuggestion(value) {
  searchQuery.value = value;
  aiSuggestions.value = [];
  performSearch();
}

function clearSearch() {
  searchPerformed.value = false;
  searchResults.value = { marketplace: [], jobs: [], professionals: [] };
  searchError.value = "";
}

// Scroll handler
function handleScroll() {
  isScrolledFar.value = window.scrollY > 300;
}

// Chart reference
const globalChart = ref(null);
let chartInstance = null;

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  fetchHomeData();

  // Initialize chart
  const ctx = document.getElementById("globalChart");
  if (ctx) {
    if (chartInstance) chartInstance.destroy();
    chartInstance = new Chart(ctx, {
      type: "line",
      data: {
        labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        datasets: [
          {
            label: "transactions (M)",
            data: [12, 19, 15, 22, 24, 30, 28],
            borderColor: "#F5B301",
            tension: 0.3,
            backgroundColor: "rgba(245,179,1,0.05)",
            fill: true,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: { legend: { display: false } },
      },
    });
  }
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
  if (chartInstance) chartInstance.destroy();
});

// Sectors data
const sectors = ref([
  { name: "Consumer Goods", icon: "fas fa-box", stats: "0" },
  { name: "Digital Services", icon: "fas fa-laptop-code", stats: "0" },
  { name: "Healthcare", icon: "fas fa-heartbeat", stats: "0" },
  { name: "Legal & Tax", icon: "fas fa-gavel", stats: "0" },
  { name: "Construction", icon: "fas fa-hard-hat", stats: "0" },
  { name: "Education", icon: "fas fa-graduation-cap", stats: "0" },
  { name: "Finance", icon: "fas fa-coins", stats: "0" },
  { name: "Logistics", icon: "fas fa-truck", stats: "0" },
]);

const activityFeed = ref([
  {
    initials: "SK",
    text: "<strong>Sarah K.</strong> bought premium design",
    time: "2 min ago",
  },
  {
    initials: "JC",
    text: "<strong>James, CPA</strong> hired for tax filing",
    time: "7 min ago",
  },
  {
    initials: "DA",
    text: "<strong>Dr. Amina</strong> consultation booked",
    time: "15 min ago",
  },
  {
    initials: "LA",
    text: "<strong>Lex Associates</strong> won contract bid",
    time: "28 min ago",
  },
]);
const pros = ref([
  {
    initials: "JD",
    name: "Dr. James Dean",
    role: "Cardiologist",
    rating: "4.98",
  },
  {
    initials: "LM",
    name: "Laura M., Esq.",
    role: "Corporate lawyer",
    rating: "4.94",
  },
  {
    initials: "RK",
    name: "Rahul Kapoor",
    role: "AWS Architect",
    rating: "4.99",
  },
]);
const activityCounter = computed(() => Math.max(activityFeed.value.length * 3, 0));

const marketplaceItems = ref([]);
const jobItems = ref([]);
const professionalItems = ref([]);

function buildInitials(name = "") {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "MS";
  return `${parts[0][0] || ""}${parts[parts.length - 1][0] || ""}`.toUpperCase();
}

function formatRelativeTime(value) {
  if (!value) return "just now";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "just now";
  const diff = Date.now() - date.getTime();
  const minutes = Math.max(1, Math.floor(diff / 60000));
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hr ago`;
  const days = Math.floor(hours / 24);
  return `${days} day${days > 1 ? "s" : ""} ago`;
}

async function fetchHomeData() {
  try {
    const [marketplaceRes, jobsRes, prosRes] = await Promise.all([
      fetch(`${API_BASE}/marketplace`).catch(() => null),
      fetch(`${API_BASE}/jobs`).catch(() => null),
      fetch(`${API_BASE}/professionals`).catch(() => null),
    ]);

    if (marketplaceRes?.ok) {
      const data = await marketplaceRes.json();
      marketplaceItems.value = data.items || [];
    }
    if (jobsRes?.ok) {
      const data = await jobsRes.json();
      jobItems.value = data.jobs || [];
    }
    if (prosRes?.ok) {
      const data = await prosRes.json();
      professionalItems.value = data.professionals || [];
    }
  } catch (error) {
    console.error("Home data load error", error);
  }

  if (professionalItems.value.length) {
    pros.value = professionalItems.value.slice(0, 3).map((pro) => ({
      initials: buildInitials(pro.name || pro.username || ""),
      name: pro.name || pro.username || "Professional",
      role: pro.professionalType || "Verified Pro",
      rating: (4.8 + Math.random() * 0.2).toFixed(2),
    }));
  }

  const feed = [];
  marketplaceItems.value.slice(0, 2).forEach((item) => {
    feed.push({
      initials: buildInitials(item.itemName || "MSA"),
      text: `<strong>User #${item.user_id || "—"}</strong> listed ${item.itemName}`,
      time: formatRelativeTime(item.createdAt),
    });
  });
  jobItems.value.slice(0, 1).forEach((job) => {
    const userName = job.user?.username || job.user?.firstName || "Employer";
    feed.push({
      initials: buildInitials(userName),
      text: `<strong>${userName}</strong> posted ${job.jobTitle}`,
      time: formatRelativeTime(job.createdAt),
    });
  });
  professionalItems.value.slice(0, 1).forEach((pro) => {
    const proName = pro.name || pro.username || "Professional";
    feed.push({
      initials: buildInitials(proName),
      text: `<strong>${proName}</strong> is now available`,
      time: "just now",
    });
  });
  activityFeed.value = feed.length ? feed : activityFeed.value;

  updateSectorStats();
}

function updateSectorStats() {
  const marketplaceCount = marketplaceItems.value.length;
  const jobsCount = jobItems.value.length;
  const proCount = professionalItems.value.length;
  const countByType = (type) =>
    professionalItems.value.filter(
      (pro) => String(pro.professionalType || "").toLowerCase() === type
    ).length;

  sectors.value = sectors.value.map((sector) => {
    if (sector.name === "Consumer Goods" && marketplaceCount) {
      return { ...sector, stats: `${marketplaceCount}` };
    }
    if (sector.name === "Digital Services" && jobsCount) {
      return { ...sector, stats: `${jobsCount}` };
    }
    if (sector.name === "Healthcare" && proCount) {
      const count = countByType("cardiology") + countByType("therapy") + countByType("fitness");
      return { ...sector, stats: `${count || proCount}` };
    }
    if (sector.name === "Legal & Tax") {
      const count = countByType("legal");
      if (count) return { ...sector, stats: `${count}` };
    }
    if (sector.name === "Education") {
      const count = countByType("university") + countByType("institution");
      if (count) return { ...sector, stats: `${count}` };
    }
    return sector;
  });
}

async function performSearch() {
  const query = searchQuery.value.trim();
  if (!query) return;

  const directRoute = resolveSearchRoute(query);
  if (directRoute) {
    router.push(directRoute);
    return;
  }

  searchLoading.value = true;
  searchError.value = "";
  searchPerformed.value = true;

  try {
    const [marketplaceRes, jobsRes, prosRes] = await Promise.all([
      fetch(`${API_BASE}/marketplace`).catch(() => null),
      fetch(`${API_BASE}/jobs`).catch(() => null),
      fetch(`${API_BASE}/professionals?query=${encodeURIComponent(query)}`).catch(() => null),
    ]);

    let marketplace = marketplaceItems.value;
    let jobs = jobItems.value;
    let professionals = professionalItems.value;

    if (marketplaceRes?.ok) {
      const data = await marketplaceRes.json();
      marketplace = data.items || [];
      marketplaceItems.value = marketplace;
    }
    if (jobsRes?.ok) {
      const data = await jobsRes.json();
      jobs = data.jobs || [];
      jobItems.value = jobs;
    }
    if (prosRes?.ok) {
      const data = await prosRes.json();
      professionals = data.professionals || [];
      professionalItems.value = professionals;
    }

    const q = query.toLowerCase();
    searchResults.value = {
      marketplace: marketplace
        .filter((item) =>
          String(item.itemName || "").toLowerCase().includes(q) ||
          String(item.category || "").toLowerCase().includes(q)
        )
        .slice(0, 4)
        .map((item) => ({
          id: item.item_id,
          title: item.itemName,
          category: item.category,
          price: item.price,
          query,
        })),
      jobs: jobs
        .filter((job) =>
          String(job.jobTitle || "").toLowerCase().includes(q) ||
          String(job.category || "").toLowerCase().includes(q)
        )
        .slice(0, 4)
        .map((job) => ({
          id: job.job_item_id,
          title: job.jobTitle,
          category: job.category,
          query,
        })),
      professionals: professionals
        .filter((pro) =>
          String(pro.name || pro.username || "").toLowerCase().includes(q) ||
          String(pro.professionalType || "").toLowerCase().includes(q)
        )
        .slice(0, 4)
        .map((pro) => ({
          id: pro.userId,
          name: pro.name || pro.username || "Professional",
          role: pro.professionalType || "Professional",
          query,
        })),
    };
  } catch (error) {
    console.error("Search error", error);
    searchError.value = "Search failed. Please try again.";
  } finally {
    searchLoading.value = false;
  }
}

function goToMarketplace(query) {
  router.push({ path: "/marketplace", query: { search: query } });
}

function goToJobs(query) {
  router.push({ path: "/jobs", query: { search: query } });
}

function goToProfessionals(query) {
  router.push({ path: "/professionals", query: { search: query } });
}

function resolveSearchRoute(query) {
  const q = query.toLowerCase();
  if (/(movie|film|trailer|music|song|video|podcast)/.test(q)) {
    return { path: "/entertainment", query: { search: query } };
  }
  if (/(ride|taxi|uber|transport)/.test(q)) {
    return { path: "/book-ride" };
  }
  if (/(course|book|ebook|library)/.test(q)) {
    return { path: "/courses-books", query: { search: query } };
  }
  if (/(job|hire|vacancy|gig)/.test(q)) {
    return { path: "/jobs", query: { search: query } };
  }
  if (/(doctor|lawyer|therapist|coach|trainer|consultant|accountant)/.test(q)) {
    return { path: "/professionals", query: { search: query } };
  }
  return null;
}

// Sector modal
const showSectorModal = ref(false);
const selectedSector = ref(null);
const sectorItems = ref([]);
const sectorPros = ref([]);
const sectorEmptyMessage = ref("");
const modalProsTitle = computed(() => {
  const sectorName = selectedSector.value?.name || "";
  if (!sectorName) return "Top professionals";
  if (["Consumer Goods", "Construction", "Finance"].includes(sectorName)) {
    return `Top sellers in ${sectorName}`;
  }
  if (sectorName === "Digital Services") {
    return `Top employers in ${sectorName}`;
  }
  return `Top professionals in ${sectorName}`;
});

const marketplaceCategoryIcons = {
  Electronics: "fas fa-mobile-alt",
  Furniture: "fas fa-couch",
  Accessories: "fas fa-gem",
  Appliances: "fas fa-blender",
  Other: "fas fa-box-open",
};

const jobCategoryIcons = {
  "Web Development": "fas fa-code",
  "Graphics Design": "fas fa-paint-brush",
  "Content Writing": "fas fa-pen-nib",
  "Digital Marketing": "fas fa-bullhorn",
  "Video and Animation": "fas fa-video",
  Other: "fas fa-briefcase",
};

const professionalTypeIcons = {
  Cardiology: "fas fa-heartbeat",
  Therapy: "fas fa-brain",
  Fitness: "fas fa-dumbbell",
  Legal: "fas fa-gavel",
  Coaching: "fas fa-user-tie",
  Corporate: "fas fa-building",
  Institution: "fas fa-school",
  University: "fas fa-university",
};

function formatPrice(value) {
  if (!Number.isFinite(value)) return "";
  return Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

function buildMarketplaceSector() {
  if (!marketplaceItems.value.length) {
    return { items: [], pros: [], emptyMessage: "No marketplace listings yet." };
  }

  const categoryMap = new Map();
  const sellerMap = new Map();

  marketplaceItems.value.forEach((item) => {
    const category = String(item.category || "Other").trim() || "Other";
    const entry = categoryMap.get(category) || { count: 0, minPrice: null };
    entry.count += 1;
    const price = Number(item.price);
    if (Number.isFinite(price)) {
      entry.minPrice = entry.minPrice === null ? price : Math.min(entry.minPrice, price);
    }
    categoryMap.set(category, entry);

    if (item.user_id) {
      const seller = sellerMap.get(item.user_id) || { count: 0 };
      seller.count += 1;
      sellerMap.set(item.user_id, seller);
    }
  });

  const items = Array.from(categoryMap.entries())
    .sort((a, b) => b[1].count - a[1].count)
    .slice(0, 4)
    .map(([category, entry]) => ({
      name: category,
      icon: marketplaceCategoryIcons[category] || marketplaceCategoryIcons.Other,
      count: entry.count,
      label: "listings",
      price: entry.minPrice,
    }));

  const pros = Array.from(sellerMap.entries())
    .sort((a, b) => b[1].count - a[1].count)
    .slice(0, 3)
    .map(([userId, entry]) => {
      const name = `Seller #${userId}`;
      return {
        name,
        initials: buildInitials(name),
        meta: `${entry.count} listings`,
      };
    });

  return { items, pros, emptyMessage: "" };
}

function buildJobsSector() {
  if (!jobItems.value.length) {
    return { items: [], pros: [], emptyMessage: "No job listings yet." };
  }

  const categoryMap = new Map();
  const employerMap = new Map();

  jobItems.value.forEach((job) => {
    const category = String(job.category || "Other").trim() || "Other";
    const entry = categoryMap.get(category) || { count: 0, minBudget: null };
    entry.count += 1;
    const min = Number(job.budgetMin);
    const max = Number(job.budgetMax);
    const candidate = Number.isFinite(min) ? min : Number.isFinite(max) ? max : null;
    if (candidate !== null) {
      entry.minBudget = entry.minBudget === null ? candidate : Math.min(entry.minBudget, candidate);
    }
    categoryMap.set(category, entry);

    const userId = job.user?.userId;
    if (userId) {
      const employer = employerMap.get(userId) || {
        count: 0,
        name: [job.user?.firstName, job.user?.lastName].filter(Boolean).join(" ").trim() || job.user?.username || `Employer #${userId}`,
      };
      employer.count += 1;
      employerMap.set(userId, employer);
    }
  });

  const items = Array.from(categoryMap.entries())
    .sort((a, b) => b[1].count - a[1].count)
    .slice(0, 4)
    .map(([category, entry]) => ({
      name: category,
      icon: jobCategoryIcons[category] || jobCategoryIcons.Other,
      count: entry.count,
      label: "jobs",
      price: entry.minBudget,
    }));

  const pros = Array.from(employerMap.entries())
    .sort((a, b) => b[1].count - a[1].count)
    .slice(0, 3)
    .map(([, entry]) => ({
      name: entry.name,
      initials: buildInitials(entry.name),
      meta: `${entry.count} jobs posted`,
    }));

  return { items, pros, emptyMessage: "" };
}

function buildProfessionalsSector(types = []) {
  const normalizedTypes = types.map((value) => String(value || "").toLowerCase());
  const filtered = professionalItems.value.filter((pro) => {
    if (!normalizedTypes.length) return true;
    return normalizedTypes.includes(String(pro.professionalType || "").toLowerCase());
  });

  if (!filtered.length) {
    return { items: [], pros: [], emptyMessage: "No professionals listed yet." };
  }

  const typeMap = new Map();
  filtered.forEach((pro) => {
    const type = String(pro.professionalType || "Professional").trim() || "Professional";
    const entry = typeMap.get(type) || { count: 0 };
    entry.count += 1;
    typeMap.set(type, entry);
  });

  const items = Array.from(typeMap.entries())
    .sort((a, b) => b[1].count - a[1].count)
    .slice(0, 4)
    .map(([type, entry]) => ({
      name: type,
      icon: professionalTypeIcons[type] || "fas fa-user-md",
      count: entry.count,
      label: "pros",
      price: null,
    }));

  const pros = filtered.slice(0, 3).map((pro) => ({
    name: pro.name || pro.username || "Professional",
    initials: buildInitials(pro.name || pro.username || ""),
    meta: pro.professionalType || "Professional",
  }));

  return { items, pros, emptyMessage: "" };
}

function openSectorModal(sector) {
  selectedSector.value = sector;
  let data = { items: [], pros: [], emptyMessage: "No listings yet." };
  if (sector.name === "Consumer Goods") {
    data = buildMarketplaceSector();
  } else if (sector.name === "Digital Services") {
    data = buildJobsSector();
  } else if (sector.name === "Healthcare") {
    data = buildProfessionalsSector(["Cardiology", "Therapy", "Fitness"]);
  } else if (sector.name === "Legal & Tax") {
    data = buildProfessionalsSector(["Legal"]);
  } else if (sector.name === "Education") {
    data = buildProfessionalsSector(["University", "Institution"]);
  }

  sectorItems.value = data.items;
  sectorPros.value = data.pros;
  sectorEmptyMessage.value = data.emptyMessage || "";

  showSectorModal.value = true;
}

function closeSectorModal() {
  showSectorModal.value = false;
}

function browseSector() {
  const sector = selectedSector.value?.name || "";
  const routes = {
    "Consumer Goods": { path: "/marketplace" },
    "Digital Services": { path: "/jobs" },
    Healthcare: { path: "/professionals", query: { type: "Cardiology" } },
    "Legal & Tax": { path: "/professionals", query: { type: "Legal" } },
    Construction: { path: "/marketplace" },
    Education: { path: "/courses-books" },
    Finance: { path: "/marketplace" },
    Logistics: { path: "/book-ride" },
  };
  router.push(routes[sector] || { path: "/marketplace" });
  closeSectorModal();
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.msa-app {
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  background: #ffffff;
  min-height: 100vh;
  overflow-x: hidden; /* Prevent horizontal scroll */
}

:root {
  --deep-blue: #0b1c2d;
  --sphere-gold: #f5b301;
  --emerald: #1fa774;
  --cloud: #ffffff;
  --graphite: #1e1e1e;
  --glass-bg: rgba(255, 255, 255, 0.75);
  --glass-border: rgba(11, 28, 45, 0.08);
}

.glass-card {
  background: var(--glass-bg);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid var(--glass-border);
  border-radius: 28px;
  box-shadow: 0 10px 25px -10px rgba(11, 28, 45, 0.05);
}

/* MS LOGO.jpg CIRCULAR CONTAINER */
.ms-logo-container {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0b1c2d;
  border: 2px solid #f5b301;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.ms-logo-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
@media (max-width: 768px) {
  .ms-logo-container {
    width: 40px;
    height: 40px;
  }
}

/* MOBILE HAMBURGER */
.hamburger-btn {
  display: none;
  width: auto;
  height: 44px;
  border-radius: 40px;
  background: white;
  color: #0b1c2d;
  font-size: 1rem;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0 16px;
}
.hamburger-btn:hover {
  background: #f5b301;
  color: #0b1c2d;
  transform: scale(1.05);
}
.menu-text {
  color: #000000;
  font-weight: 600;
}

.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(11, 28, 45, 0.5);
  backdrop-filter: blur(4px);
  z-index: 200;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}
.mobile-menu-overlay.active {
  opacity: 1;
  visibility: visible;
}

.mobile-menu-panel {
  position: fixed;
  top: 0;
  left: -80%;
  width: 80%;
  max-width: 320px;
  height: 100vh;
  background: white;
  z-index: 250;
  transition: left 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 10px 0 30px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  padding: 32px 24px;
  max-height: 100vh;
  overflow-y: auto;
}
.mobile-menu-panel.active {
  left: 0;
}

.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
}

.close-btn {
  font-size: 1.6rem;
  color: #64748b;
  background: none;
  border: none;
  cursor: pointer;
}

.menu-label {
  font-weight: 700;
  color: #0b1c2d;
  margin-bottom: 8px;
  padding-left: 8px;
}

.mobile-menu-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border-radius: 16px;
  font-weight: 600;
  color: #1e1e1e;
  transition: all 0.2s ease;
  margin-bottom: 4px;
  text-decoration: none;
}
.mobile-menu-item:hover {
  background: #f8fafc;
  transform: translateX(8px);
  color: #f5b301;
}
.mobile-menu-item:active {
  background: #f5b30120;
  transform: scale(0.98);
}

.donate-mobile-item i {
  color: #f5b301;
}
.donate-mobile-item:hover i {
  color: #f5b301;
}

.roles-mobile-item i {
  color: #f5b301;
}
.roles-mobile-item:hover i {
  color: #f5b301;
}

.mobile-menu-login {
  background: #0b1c2d;
  color: white;
  border-radius: 40px;
  padding: 16px 24px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
  transition: all 0.2s ease;
  text-decoration: none;
  margin-bottom: 20px;
}
.mobile-menu-login:hover {
  background: #f5b301;
  color: #0b1c2d;
  transform: translateY(-2px);
}

/* AI ASSISTANT */
.ai-assistant {
  position: fixed;
  bottom: 100px;
  right: 20px;
  z-index: 999;
}
@media (max-width: 768px) {
  .ai-assistant {
    bottom: 90px;
    right: 16px;
  }
}

.ai-chat-toggle {
  width: 56px;
  height: 56px;
  background: #0b1c2d;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.6rem;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(11, 28, 45, 0.3);
  border: 2px solid #f5b301;
  transition: all 0.2s ease;
  position: relative;
}
.ai-chat-toggle:hover {
  transform: scale(1.1);
  background: #f5b301;
  color: #0b1c2d;
}
.ai-chat-toggle.dim {
  opacity: 0.6;
}
.ai-text {
  color: white;
  font-weight: 800;
  font-size: 1.4rem;
}
.ai-chat-toggle[title] {
  position: relative;
}
.ai-chat-toggle[title]:hover::after {
  content: attr(title);
  position: absolute;
  bottom: 70px;
  right: 0;
  background: #0b1c2d;
  color: white;
  padding: 8px 16px;
  border-radius: 40px;
  font-size: 0.8rem;
  white-space: nowrap;
  border: 1px solid #f5b301;
  z-index: 1000;
}

.ai-pulse {
  position: absolute;
  top: 0;
  right: 0;
  width: 14px;
  height: 14px;
  background: #1fa774;
  border-radius: 50%;
  border: 2px solid white;
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}

.ai-chat-window {
  position: absolute;
  bottom: 70px;
  right: 0;
  width: 320px;
  height: 450px;
  background: white;
  border-radius: 28px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  border: 1px solid #e2e8f0;
}
@media (max-width: 640px) {
  .ai-chat-window {
    width: 300px;
    height: 500px;
    position: fixed;
    bottom: 80px;
    right: 16px;
  }
}

.ai-chat-messages {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

.ai-chat-header {
  position: sticky;
  top: 0;
  background: white;
  padding: 20px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
  flex-shrink: 0;
}

.ai-header-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ai-avatar {
  background: #f5b301;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ai-avatar i {
  color: #0b1c2d;
}

.ai-name {
  font-weight: 800;
  font-size: 0.95rem;
  display: block;
}
.ai-status {
  display: block;
  font-size: 0.65rem;
  color: #1fa774;
}

.ai-close {
  font-size: 1.6rem;
  background: none;
  border: none;
  cursor: pointer;
  color: #64748b;
}

.ai-message {
  padding: 14px 18px;
  border-radius: 20px;
  max-width: 85%;
  margin-bottom: 8px;
}
.ai-message.bot {
  background: #f1f5f9;
  border-bottom-left-radius: 4px;
}
.ai-message.user {
  background: #0b1c2d;
  color: white;
  margin-left: auto;
  border-bottom-right-radius: 4px;
}

.ai-chat-input {
  position: sticky;
  bottom: 0;
  background: white;
  padding: 16px 20px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
}

.ai-input-field {
  flex: 1;
  padding: 12px 16px;
  border-radius: 60px;
  border: 1px solid #e2e8f0;
  font-size: 0.9rem;
  transition: all 0.2s;
  outline: none;
  width: calc(100% - 80px);
}
.ai-input-field:focus {
  border-color: #f5b301;
  box-shadow: 0 0 0 3px rgba(245, 179, 1, 0.1);
}
@media (max-width: 640px) {
  .ai-input-field {
    width: calc(100% - 70px);
    padding: 12px 14px;
  }
}

.ai-submit-btn {
  width: 70px;
  height: 44px;
  border-radius: 60px;
  background: #f5b301;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
  border: none;
  cursor: pointer;
}
.ai-submit-btn:hover {
  transform: scale(1.05);
  background: #0b1c2d;
}
.send-text {
  color: white;
  font-weight: 700;
  font-size: 0.9rem;
}
@media (max-width: 640px) {
  .ai-submit-btn {
    width: 60px;
  }
  .send-text {
    font-size: 0.8rem;
  }
}

/* MOBILE BOTTOM NAV */
.mobile-bottom-nav {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 -8px 20px rgba(0, 0, 0, 0.02);
  border-top: 1px solid #edf2f7;
  padding: 12px 16px;
  justify-content: space-around;
  z-index: 60;
}
.mobile-bottom-nav a {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #64748b;
  font-size: 0.7rem;
  transition: all 0.2s;
  text-decoration: none;
}
.mobile-bottom-nav a i {
  font-size: 1.2rem;
  margin-bottom: 4px;
}
.mobile-bottom-nav a.active {
  color: #f5b301;
}
.roles-mobile-nav {
  color: #f5b301 !important;
}
.roles-mobile-nav i {
  color: #f5b301;
}
.donate-mobile-nav {
  color: #f5b301 !important;
}
.donate-mobile-nav i {
  color: #f5b301;
}

@media (max-width: 768px) {
  .mobile-bottom-nav {
    display: flex;
  }
  
  /* Add bottom padding to body to account for fixed bottom nav */
  body {
    padding-bottom: 80px !important;
    margin-bottom: 0 !important;
  }
  
  /* Ensure footer is not hidden behind bottom nav */
  .footer {
    margin-bottom: 80px !important;
    padding-bottom: 24px !important;
  }
}

.btn-hover-effect {
  transition: all 0.2s ease;
}
.btn-hover-effect:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(11, 28, 45, 0.1);
}

.gold-text {
  color: #f5b301;
}
.deep-blue {
  color: #0b1c2d;
}
.positive {
  color: #1fa774;
}

.trust-badge {
  display: inline-block;
  background: rgba(31, 167, 116, 0.1);
  color: #0b5e42;
  padding: 4px 12px;
  border-radius: 100px;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: left;
  margin-left: 0;
  align-self: flex-start;
}
.badge-verified {
  background: #1fa774;
  color: white;
  border-radius: 20px;
  padding: 2px 10px;
  font-size: 0.7rem;
  display: inline-flex;
  align-items: center;
}

/* PC LAYOUT */
@media (min-width: 769px) {
  .desktop-header-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 12px 24px 8px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(245, 179, 1, 0.2);
    position: sticky;
    top: 0;
    z-index: 50;
  }
  .brand-row {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 10px;
    width: 100%;
  }
  .brand-row span {
    font-weight: 900 !important;
    font-size: 1.6rem !important;
    color: #0b1c2d;
    letter-spacing: -0.5px;
    white-space: nowrap;
  }
  .brand-row .hamburger-btn {
    display: none !important;
  }
  .desktop-nav {
    display: flex !important;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 20px;
    font-weight: 600;
    color: #1e1e1e;
    width: 100%;
    font-size: 0.75rem;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }
  .desktop-nav a {
    padding: 4px 0;
    white-space: nowrap;
    transition: color 0.1s;
    text-decoration: none;
    color: #1e1e1e;
  }
  .desktop-nav a:hover {
    color: #f5b301;
  }
  .desktop-nav a.active {
    color: #0b1c2d;
    border-bottom: 2px solid #f5b301;
    padding-bottom: 2px;
  }
  .roles-nav-link {
    color: #f5b301 !important;
    font-weight: 700 !important;
  }
  .roles-nav-link i {
    color: #f5b301;
  }
  .donate-nav-link {
    color: #f5b301 !important;
    font-weight: 700 !important;
  }
  .donate-nav-link i {
    color: #f5b301;
  }
  .desktop-login-btn {
    background: #0b1c2d !important;
    color: white !important;
    padding: 4px 14px !important;
    border-radius: 40px;
    font-size: 0.7rem !important;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-left: 4px;
    border: 1px solid #0b1c2d;
    transition: all 0.2s;
    text-decoration: none;
  }
  .desktop-login-btn:hover {
    background: #f5b301 !important;
    color: #0b1c2d !important;
    border-color: #f5b301;
    transform: scale(0.98);
  }

  /* Left alignment fixes for PC */
  .hero-section {
    align-items: flex-start;
    text-align: left;
  }
  .hero-content {
    text-align: left;
    margin-left: 0;
    padding-left: 0;
  }
  .economy-os {
    display: block;
    text-align: left;
  }
  .trust-badge {
    margin-left: 0;
    text-align: left;
  }
  .hero-title {
    text-align: left;
  }
  .hero-description {
    text-align: left;
  }
  .volume-card {
    text-align: left;
  }
  .volume-card h3, .volume-card p, .volume-card .volume-badges {
    text-align: left;
    justify-content: flex-start;
  }
  .footer-main {
    justify-content: space-between;
  }
  .footer-brand {
    text-align: left;
  }
  .footer-links {
    justify-content: flex-end;
  }
  .footer-column {
    text-align: left;
  }
  .footer-column a {
    text-align: left;
  }
  .footer-tagline {
    text-align: left;
  }
}

/* MOBILE LAYOUT */
@media (max-width: 768px) {
  .desktop-header-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(245, 179, 1, 0.2);
    position: sticky;
    top: 0;
    z-index: 50;
    width: 100%;
  }
  .brand-row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 0;
  }
  .brand-row span {
    font-weight: 800;
    font-size: 0.95rem;
    color: #0b1c2d;
    letter-spacing: -0.2px;
    white-space: normal;
    word-break: keep-all;
    line-height: 1.2;
    max-width: none;
    flex-shrink: 1;
  }
  .brand-row .hamburger-btn {
    display: flex !important;
    margin-left: auto;
    flex-shrink: 0;
  }
  .desktop-nav {
    display: none !important;
  }

  /* Hero text break */
  .hero-text-line {
    display: block;
  }

  /* Search bar compact on mobile */
  .search-container {
    padding: 4px !important;
  }
  .search-icon {
    margin: 0 8px !important;
  }
  .search-input {
    padding: 10px 0 !important;
    font-size: 0.85rem !important;
  }
  .search-btn {
    padding: 8px 20px !important;
    font-size: 0.85rem !important;
  }

  /* Left alignment for mobile */
  .hero-section {
    align-items: flex-start;
    text-align: left;
  }
  .hero-content {
    text-align: left;
  }
  .hero-title {
    text-align: left;
  }
  .trust-badge {
    text-align: left;
    margin-left: 0;
  }
  .hero-description {
    text-align: left;
  }
  .footer-brand {
    text-align: left;
  }
  .footer-tagline {
    text-align: left;
  }
  .footer-column {
    text-align: left;
  }
  .footer-column a {
    text-align: left;
  }
  
  /* Mobile menu full scroll */
  .mobile-menu-panel {
    max-height: 100vh;
    overflow-y: auto;
    padding-bottom: 40px;
  }
  
  .mobile-menu-login {
    margin-bottom: 30px;
  }
}

/* Support Section */
.support-section {
  padding: 20px 24px 40px;
}
.support-card {
  background: linear-gradient(145deg, #0b1c2d, #1a3347);
  border-radius: 48px;
  padding: 48px;
  color: white;
  position: relative;
  overflow: hidden;
}
.support-card::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(245,179,1,0.1) 0%, transparent 70%);
  animation: rotate 30s linear infinite;
}
@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.support-content {
  display: flex;
  align-items: center;
  gap: 48px;
  position: relative;
  z-index: 1;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .support-card {
    padding: 32px 24px;
  }
  .support-content {
    flex-direction: column;
    text-align: center;
    gap: 24px;
  }
}
.support-icon-container {
  position: relative;
  width: 120px;
  height: 120px;
  flex-shrink: 0;
}
.support-icon {
  font-size: 5rem;
  color: #f5b301;
  position: absolute;
  top: 0;
  left: 0;
  animation: heartbeat 1.5s ease-in-out infinite;
}
.support-icon-secondary {
  font-size: 3rem;
  color: rgba(245,179,1,0.3);
  position: absolute;
  bottom: 0;
  right: 0;
  animation: float 3s ease-in-out infinite;
}
@keyframes heartbeat {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}
@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}
.support-text {
  flex: 1;
}
.support-title {
  font-size: 2.2rem;
  font-weight: 800;
  margin-bottom: 16px;
  line-height: 1.2;
}
@media (max-width: 768px) {
  .support-title {
    font-size: 1.8rem;
  }
}
.support-description {
  font-size: 1.1rem;
  color: rgba(255,255,255,0.9);
  margin-bottom: 24px;
  line-height: 1.6;
}
.support-stats {
  display: flex;
  gap: 32px;
  margin-bottom: 32px;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .support-stats {
    justify-content: center;
  }
}
.support-stat {
  text-align: left;
}
@media (max-width: 768px) {
  .support-stat {
    text-align: center;
  }
}
.stat-number {
  display: block;
  font-size: 1.8rem;
  font-weight: 800;
  color: #f5b301;
}
.stat-label {
  font-size: 0.8rem;
  color: rgba(255,255,255,0.7);
}
.support-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: #f5b301;
  color: #0b1c2d;
  padding: 16px 40px;
  border-radius: 60px;
  font-weight: 700;
  font-size: 1.1rem;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
.support-btn:hover {
  background: white;
  transform: translateY(-4px);
  box-shadow: 0 20px 30px -10px rgba(0,0,0,0.3);
}
.support-btn i {
  animation: heartbeat 1.5s ease-in-out infinite;
}

/* Sector cards clickable */
.sector-card {
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}
.sector-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 30px -8px rgba(11, 28, 45, 0.15);
}
.sector-card:active {
  transform: scale(0.98);
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(11, 28, 45, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-content {
  max-width: 700px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  background: white;
  border-radius: 48px;
  padding: 32px;
}
@media (max-width: 768px) {
  .modal-content {
    padding: 24px;
  }
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.modal-title {
  font-size: 1.8rem;
  font-weight: 800;
}
.modal-icon {
  color: #f5b301;
  margin-right: 12px;
}
.modal-close {
  font-size: 2rem;
  background: none;
  border: none;
  cursor: pointer;
}
.modal-stats {
  margin-bottom: 24px;
}
.stats-badge {
  background: #0b1c2d;
  color: white;
  padding: 8px 24px;
  border-radius: 60px;
  font-weight: 600;
}
.modal-description {
  color: #4a5568;
  margin-bottom: 28px;
}
.modal-empty {
  color: #64748b;
  font-size: 0.95rem;
  margin: 8px 0 28px;
}
.modal-items-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 28px;
}
.modal-item {
  padding: 20px;
}
.item-icon {
  font-size: 1.6rem;
  color: #f5b301;
  margin-bottom: 12px;
}
.item-name {
  font-weight: 700;
  margin-bottom: 4px;
}
.item-providers {
  color: #64748b;
  font-size: 0.85rem;
}
.item-price {
  font-weight: 600;
  margin-top: 8px;
}
.modal-pros-section {
  background: #f8fafc;
  border-radius: 24px;
  padding: 24px;
  margin-bottom: 28px;
}
.modal-pros-title {
  font-weight: 700;
  margin-bottom: 16px;
}
.modal-pro-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #e2e8f0;
}
.modal-pro-avatar {
  width: 48px;
  height: 48px;
  background: #0b1c2d;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f5b301;
  font-weight: 700;
}
.modal-pro-info {
  flex: 1;
}
.modal-pro-details {
  font-size: 0.8rem;
  color: #64748b;
}
.modal-actions {
  display: flex;
  gap: 16px;
}
.modal-browse-btn,
.modal-close-btn {
  flex: 1;
  padding: 16px !important;
}

/* Hero section */
.hero-section {
  padding: 20px 24px 40px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 30px;
}
.hero-content {
  flex: 1 1 300px;
}
.hero-title {
  font-size: 2.8rem;
  font-weight: 800;
  line-height: 1.1;
  margin: 24px 0 16px;
  color: #0b1c2d;
  letter-spacing: -1px;
}
.economy-os {
  display: inline;
}
.hero-description {
  font-size: 1.1rem;
  color: #4a5568;
  margin-bottom: 28px;
}
.hero-sphere {
  flex: 0 1 240px;
  display: flex;
  justify-content: center;
}
.sphere-container {
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, #0b1c2d, #1a3347);
  box-shadow: 0 0 0 8px rgba(245, 179, 1, 0.1);
  position: relative;
  animation: pulse-sphere 6s infinite;
}
@keyframes pulse-sphere {
  0% {
    box-shadow: 0 0 0 8px rgba(245, 179, 1, 0.1);
  }
  50% {
    box-shadow: 0 0 0 12px rgba(245, 179, 1, 0.15);
  }
}
.sphere-inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-weight: 800;
  font-size: 1.8rem;
}
.sphere-dot {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.gold-dot {
  background: #f5b301;
  top: 30px;
  left: 50px;
}
.green-dot {
  background: #1fa774;
  width: 14px;
  height: 14px;
  bottom: 50px;
  right: 50px;
}
.globe-icon {
  position: absolute;
  font-size: 3rem;
  color: rgba(255, 255, 255, 0.3);
  bottom: 20px;
  left: 20px;
}

/* Search bar */
.search-container {
  background: white;
  border-radius: 100px;
  border: 1px solid #e2e8f0;
  padding: 6px;
  display: flex;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}
.search-icon {
  margin: 0 16px;
  color: #1fa774;
  align-self: center;
}
.search-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 14px 0;
  font-size: 0.95rem;
  background: transparent;
}
.search-btn {
  background: #f5b301;
  border-radius: 60px;
  padding: 12px 28px;
  font-weight: 600;
  color: #0b1c2d;
  transition: all 0.2s;
  border: none;
  cursor: pointer;
}

.ai-suggestions {
  margin-top: 16px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.suggestion-item {
  background: #eef2f6;
  padding: 6px 20px;
  border-radius: 40px;
  font-size: 0.9rem;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #0b1c2d;
  transition: all 0.2s ease;
}
.suggestion-item:hover {
  background: #f5b301;
  color: #0b1c2d;
}

.search-results {
  margin-top: 20px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 16px;
  box-shadow: 0 12px 30px rgba(11, 28, 45, 0.08);
}
.search-results-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  color: #0b1c2d;
}
.search-results-count {
  margin-left: 8px;
  font-size: 0.85rem;
  color: #64748b;
}
.search-clear {
  padding: 6px 12px;
  font-size: 0.75rem;
}
.search-group {
  margin-bottom: 12px;
}
.search-group h4 {
  font-size: 0.95rem;
  margin-bottom: 8px;
  color: #0b1c2d;
}
.search-cards {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.search-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #f8fafc;
  border-radius: 14px;
  padding: 10px 14px;
}
.search-meta {
  font-size: 0.82rem;
  color: #64748b;
  margin-top: 4px;
}
.search-results-empty {
  padding: 12px 0;
  color: #64748b;
  font-size: 0.9rem;
}
.search-results-empty.error {
  color: #b91c1c;
}

/* Sectors section */
.sectors-section {
  padding: 20px 24px;
}
.section-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 24px;
  text-align: center;
}
.sectors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 20px;
}
.sector-card {
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.sector-icon {
  font-size: 2rem;
  color: #0b1c2d;
  margin-bottom: 16px;
}
.sector-name {
  font-weight: 700;
  margin-bottom: 8px;
}
.sector-stats {
  color: #1fa774;
  font-size: 0.85rem;
}

/* Activity section */
.activity-section {
  padding: 20px 24px 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}
.activity-feed {
  flex: 2 1 300px;
}
.activity-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.activity-title {
  font-weight: 700;
  font-size: 1.5rem;
}
.activity-counter {
  background: #e2e8f0;
  padding: 6px 16px;
  border-radius: 50px;
  font-size: 0.8rem;
}
.feed-container {
  margin-top: 20px;
  background: #f9fbfd;
  border-radius: 28px;
  padding: 24px;
}
.feed-item {
  display: flex;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #ecf1f7;
  align-items: flex-start;
}
.feed-icon {
  background: #0b1c2d;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  font-weight: 700;
  flex-shrink: 0;
}
.feed-content {
  flex: 1;
}
.feed-text-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.feed-text {
  font-size: 0.95rem;
  line-height: 1.4;
}
.feed-time {
  font-size: 0.75rem;
  color: #718096;
  white-space: nowrap;
}
@media (max-width: 480px) {
  .feed-text-wrapper {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  .feed-text {
    width: 100%;
  }
}

.verified-pros {
  flex: 1 1 240px;
}
.pros-title {
  font-weight: 700;
  font-size: 1.5rem;
  text-align: left;
}
.pros-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
}
.pro-card {
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.pro-avatar {
  width: 44px;
  height: 44px;
  background: #0b1c2d;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f5b301;
  font-weight: 800;
  font-size: 1.1rem;
  flex-shrink: 0;
}
.pro-info {
  flex: 1;
  text-align: left;
}
.pro-name {
  display: block;
  font-weight: 700;
  margin-bottom: 2px;
}
.pro-details {
  font-size: 0.8rem;
  color: #64748b;
}

/* Steps section */
.steps-section {
  padding: 40px 24px;
  background: rgba(31, 167, 116, 0.02);
  border-radius: 56px;
  margin: 0 24px 40px;
}
.steps-title {
  font-size: 2rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 40px;
}
.steps-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 50px;
}
.step-item {
  text-align: center;
  max-width: 220px;
}
.step-number {
  background: #0b1c2d;
  color: white;
  width: 50px;
  height: 50px;
  display: inline-flex;
  border-radius: 30px;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  margin-bottom: 16px;
}
.step-heading {
  font-weight: 700;
  margin-bottom: 8px;
}
.step-description {
  color: #4a5568;
}

/* Stats section */
.stats-section {
  padding: 20px 24px 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
.chart-container {
  flex: 1;
  min-width: 260px;
}
.chart-header {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 16px;
}
.chart-icon {
  font-size: 2.2rem;
  color: #f5b301;
}
.chart-title {
  font-weight: 700;
}
.chart-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
.chart-growth {
  color: #1fa774;
}
.chart-countries {
  color: #0b1c2d;
}
.chart-countries strong {
  font-weight: 800;
}
.volume-card {
  flex: 1;
  background: #0b1c2d;
  border-radius: 32px;
  padding: 28px;
  color: white;
  text-align: left;
}
.volume-number {
  font-weight: 700;
  font-size: 1.6rem;
  margin-bottom: 8px;
  text-align: left;
}
.volume-label {
  color: rgba(255, 255, 255, 0.7);
  text-align: left;
}
.volume-badges {
  display: flex;
  gap: 16px;
  margin-top: 20px;
  justify-content: flex-start;
}
.badge-outline {
  border: 1px solid #f5b301;
  padding: 8px 20px;
  border-radius: 40px;
  color: #f5b301;
}
.badge-solid {
  background: #f5b301;
  color: #0b1c2d;
  padding: 8px 20px;
  border-radius: 40px;
  font-weight: 600;
}

/* Footer */
.footer {
  background: #0b1c2d;
  color: white;
  padding: 48px 32px 24px;
  border-radius: 48px 48px 0 0;
  margin-top: 20px;
  width: 100%;
  position: relative;
  z-index: 10;
  clear: both;
}
.footer-main {
  display: flex;
  flex-wrap: wrap;
  gap: 60px;
  justify-content: space-between;
}
.footer-brand {
  max-width: 300px;
  text-align: left;
}
.footer-logo {
  width: 56px;
  height: 56px;
  margin-bottom: 16px;
}
.footer-brand-name {
  font-weight: 700;
  font-size: 1.2rem;
  color: white;
  text-align: left;
}
.footer-tagline {
  color: #a0aec0;
  font-size: 0.85rem;
  text-align: left;
}
.footer-guide-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f5b301;
  color: #0b1c2d;
  padding: 10px 20px;
  border-radius: 40px;
  font-weight: 600;
  font-size: 0.85rem;
  text-decoration: none;
  margin-top: 16px;
  transition: all 0.2s ease;
}
.footer-guide-btn:hover {
  background: white;
  transform: translateY(-2px);
}
.footer-links {
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
}
.footer-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
}
.footer-column strong {
  margin-bottom: 8px;
  text-align: left;
}
.footer-column a {
  color: #cbd5e0;
  font-size: 0.85rem;
  text-decoration: none;
  text-align: left;
}
.footer-column a:hover {
  color: #f5b301;
}
.footer-donate-link {
  color: #f5b301 !important;
  font-weight: 600;
}
.footer-role-link {
  color: #f5b301 !important;
  font-weight: 600;
}
.footer-copyright {
  border-top: 1px solid #2d404f;
  margin-top: 40px;
  padding-top: 24px;
  text-align: center;
  color: #a0aec0;
  font-size: 0.8rem;
}

/* Mobile footer fixes */
@media (max-width: 768px) {
  .footer {
    padding: 40px 24px 20px;
    margin-top: 20px;
    border-radius: 32px 32px 0 0;
    margin-bottom: 80px; /* Add space for bottom nav */
  }
  
  .footer-main {
    gap: 40px;
    flex-direction: column;
  }
  
  .footer-brand {
    max-width: 100%;
    text-align: left;
  }
  
  .footer-links {
    gap: 30px;
    justify-content: flex-start;
    width: 100%;
  }
  
  .footer-column {
    min-width: 120px;
  }
  
  .footer-copyright {
    margin-top: 30px;
    padding-top: 20px;
    font-size: 0.75rem;
    line-height: 1.5;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 32px 20px 16px;
    margin-bottom: 80px;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 24px;
  }
  
  .footer-column {
    width: 100%;
  }
}

.btn-primary {
  background: #0b1c2d;
  color: white;
  padding: 12px 24px;
  border-radius: 60px;
  font-weight: 600;
  transition: all 0.2s ease;
  border: none;
  cursor: pointer;
}
.btn-primary:hover {
  background: #f5b301;
  color: #0b1c2d;
  transform: translateY(-2px);
}

.btn-outline {
  border: 1px solid #0b1c2d;
  background: white;
  color: #0b1c2d;
  padding: 12px 24px;
  border-radius: 60px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.btn-outline:hover {
  background: #f5b30120;
  border-color: #f5b301;
  transform: translateY(-2px);
}
</style>
